// Helper
const StringIsNumber = (value: string) => !isNaN(Number(value));

// Turn enum into array
export function IntEnumToArray(enumme: any) {
  return Object.keys(enumme)
    .filter(StringIsNumber)
    .map((key) => +key);
}
